<template>
  <div class="calendar-wrapper" ref="content">
    <div class="calendar-header"  ref="title">
      <div>
        <div>
          <div class="calendar-header-date">{{ currentMonth.format("YYYY年") }}收益目标</div>
          <div class="calendar-header-btns">
            <!-- <span style="font-size:12px;">单位：元</span> -->
            <button @click="getPrevMonth()">
              <i class="fa fa-chevron-left" aria-hidden="true"></i>
            </button>
            <button @click="getNextMonth()">
              <i class="fa fa-chevron-right" aria-hidden="true"></i>
            </button>
            <button @click="getCurMonth()" title="回到当月">
              <i class="fa fa-repeat" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <!-- <div class="inputPs">
          <div class="inputP">
            <span>商务发展部月收益:</span>
            <p v-if="valueFales">{{ headData.BusinessDep }}</p>
            <el-input type="number" @input="numberChange(arguments[0], 99999999, 1)"
              @change="numberChange(arguments[0], 99999999, 1)" v-model="valueBusinessDep" class="numrule" v-else />
            <el-input type="number"  class="numrule" v-else v-model="valueBusinessDep" @input="maxNum"></el-input>
          </div>
          <div class="inputP">
            <span>项目管理部:</span>
            <p v-if="valueFales">{{ headData.ProjectMgrDep }}</p>
            <el-input type="number" @input="numberChange(arguments[0], 99999999, 2)"
              @change="numberChange(arguments[0], 99999999, 2)" class="numrule" v-else v-model="valueProjectMgrDep">
            </el-input>
          </div>
          <div class="inputP">
            <span>招募业务部:</span>
            <p v-if="valueFales">{{ headData.RecBusDep }}</p>
            <el-input type="number" class="numrule" v-else v-model="valueRecBusDep"
              @input="numberChange(arguments[0], 99999999, 3)" @change="numberChange(arguments[0], 99999999, 3)">
            </el-input>
          </div>
          <div class="inputP">
            <span>样本费用:</span>
            <p v-if="valueFales">{{ headData.SampleDep }}</p>
            <el-input type="number" class="numrule" v-else v-model="valueSampleDep"
              @input="numberChange(arguments[0], 99999999, 4)" @change="numberChange(arguments[0], 99999999, 4)">
            </el-input>
          </div>
          <div class="inputP">
            <span>耗材费用:</span>
            <p v-if="valueFales">{{ headData.ConsumablesDep }}</p>
            <el-input type="number" class="numrule" v-else v-model="valueConsumablesDep"
              @input="numberChange(arguments[0], 99999999, 5)" @change="numberChange(arguments[0], 99999999, 5)">
            </el-input>
          </div>
          <div class="inputP">
            <span>临床协调部:</span>
            <p v-if="valueFales">{{ headData.ClinicalDep }}</p>
            <el-input type="number" class="numrule" v-else v-model="valueClinicalDep"
              @input="numberChange(arguments[0], 99999999, 6)" @change="numberChange(arguments[0], 99999999, 6)">
            </el-input>
          </div>
          <div>
            <el-button :type="valueFales ? 'primary' : 'success'" round size="mini" @click="switchClick">
              <span v-if="valueFales">编辑</span>
              <span v-else>保存</span>
            </el-button>
          </div>
        </div> -->
      </div>
    </div>
      <div class="calendar-body">
        <el-table
          :data="tableData"
          size="mini"
          :key="tableKey"
          border
          :max-height="tableHeight"
          @header-dragend="$store.commit('handleHeaderDragend', arguments)"
          ref="shake"
          v-loading="successButton"
          :summary-method="getSummaries"
          show-summary
        >
          <el-table-column show-overflow-tooltip
            prop="moon"
            label="月份"
            width="100px"
            
          >
          </el-table-column>
          <el-table-column show-overflow-tooltip
            prop="BusinessDep"
            label="商务发展部"
            
            min-width="100px"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.judge" >
                <el-input 
                  type="number" 
                  class="table-numrule" 
                  size="mini"
                  v-model="editTableData.BusinessDep"
                  @input="numberChange(arguments[0], 99999999, 7)"
                  @change="numberChange(arguments[0], 99999999, 7)"
                >
                </el-input>
              </div>
              <div v-else>{{ scope.row.BusinessDep }}</div>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip
            prop="ProjectMgrDep"
            label="项目管理部"
            
            min-width="100px"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.judge">
                <el-input 
                  type="number" 
                  class="table-numrule" 
                  size="mini"
                  v-model="editTableData.ProjectMgrDep"
                  @input="numberChange(arguments[0], 99999999, 8)"
                  @change="numberChange(arguments[0], 99999999, 8)">
                </el-input>
              </div>
              <div  v-else>{{ scope.row.ProjectMgrDep }}</div>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip
            prop="RecBusDep"
            label="招募业务部"
            
            min-width="100px"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.judge">
                <el-input 
                  type="number" 
                  class="table-numrule" 
                  size="mini"
                  v-model="editTableData.RecBusDep"
                  @input="numberChange(arguments[0], 99999999, 9)"
                  @change="numberChange(arguments[0], 99999999, 9)"
                ></el-input>
            </div>
            <div v-else>{{ scope.row.RecBusDep }}</div>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip
            prop="SampleDep"
            label="样本费用"
            
            min-width="100px"
          >
          <template slot-scope="scope">
          <div v-if="scope.row.judge">
            <el-input 
                type="number" 
                class="table-numrule" 
                size="mini"
                v-model="editTableData.SampleDep"
                @input="numberChange(arguments[0], 99999999, 9)"
                @change="numberChange(arguments[0], 99999999, 9)"
                ></el-input>
            </div>
            <div v-else>{{ scope.row.SampleDep }}</div>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip
            prop="ConsumablesDep"
            label="耗材费用"
            
            min-width="100px"
          >
            <template slot-scope="scope">
            <div v-if="scope.row.judge">
              <el-input 
                type="number" 
                class="table-numrule" 
                size="mini"
                v-model="editTableData.ConsumablesDep"
                @input="numberChange(arguments[0], 99999999, 9)"
                @change="numberChange(arguments[0], 99999999, 9)"
              ></el-input>
            </div>
            <div v-else>{{ scope.row.ConsumablesDep }}</div>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip
            prop="ClinicalDep"
            label="临床协调部"
            
            min-width="100px"
          >
            <template slot-scope="scope">
            <div v-if="scope.row.judge">
              <el-input 
                type="number" 
                class="table-numrule" 
                size="mini"
                v-model="editTableData.ClinicalDep"
                @input="numberChange(arguments[0], 99999999, 9)"
                @change="numberChange(arguments[0], 99999999, 9)"
              ></el-input>
            </div>
            <div v-else>{{ scope.row.ClinicalDep }}</div>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="total" label="汇总"></el-table-column> 
          <el-table-column show-overflow-tooltip 
            label="操作" 
            fixed="right"
            width="150px">
            <template slot-scope="scope">
              <div v-if="!scope.row.judge"  >
                <el-button
                type="primary"  
                size="mini" 
                @click="setCapitalincomeDayPlan(scope.row)"
                >编辑</el-button>
              </div>
              <div v-else>
                <el-button 
                type="success"   
                size="mini" 
                @click="setCapitalincomeDayPlan(scope.row)"
                >保存</el-button>
                <el-button 
                type="danger" 
                size="mini" 
                @click="cancelMiddle(scope.row)"
              >取消</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 日历形式的表格代码 - 暂时隐藏掉 -->
      <!-- <div class="calendar-body-header">
        <div class="calendar-body-days-item calendar-body-header-item" v-for="(w, index) in weekNames" :key="index">{{
          w
        }}</div>
      </div>
      <div class="calendar-body-days" v-for="(line, index) in currentMonthData" :key="index">
        <div class="calendar-body-days-item" v-for="(d, idx) in line.weekDays" :key="idx"
          :class="{ 'calendar-body-days-item-disabled': !d.isCurMonth }"
          :style="{ background: (d.isCurMonth && d.date == date ? '#e7a23d33' : '') }">
          <div class="calendar-body-days-h">
            <div class="calendar-body-days-h-date" :style="{ color: (d.isCurMonth && d.date == date ? 'red' : '') }">{{
              d.day
            }}日</div>
            <div class="dayClass">
              <div class="dayClass_div" v-if="d.isCurMonth">
                <div>
                  <div class="inputP">
                    <span>样本费用:</span>
                    <el-input type="number" class="numrule" v-if="d.judge" v-model="SampleCost"
                      @input="numberChange(arguments[0], 99999999, 7)"
                      @change="numberChange(arguments[0], 99999999, 7)"></el-input>
                    <span class="spans" v-else>{{ d.SampleCost }}</span>
                  </div>
                  <div class="inputP">
                    <span>耗材费用:</span>
                    <el-input type="number" class="numrule" v-if="d.judge" v-model="ConsumablesCost"
                      @input="numberChange(arguments[0], 99999999, 8)"
                      @change="numberChange(arguments[0], 99999999, 8)"></el-input>
                    <span class="spans" v-else>{{ d.ConsumablesCost }}</span>
                  </div>
                  <div class="inputP">
                    <span>招募费用:</span>
                    <el-input type="number" class="numrule" v-if="d.judge" v-model="RecruitCost"
                      @input="numberChange(arguments[0], 99999999, 9)"
                      @change="numberChange(arguments[0], 99999999, 9)"></el-input>
                    <span class="spans" v-else>{{ d.RecruitCost }}</span>
                  </div>
                </div>
                <div class="dayClass_btn">
                  <el-button :type="d.judge ? 'success' : 'primary'" round size="mini"
                    @click="setCapitalincomeDayPlan(d)">
                    <span v-if="d.judge">保存</span>
                    <span v-else>编辑</span>
                  </el-button>
                  <el-button type="danger" round size="mini" @click="cancelMiddle(d)" v-if="d.judge">取消</el-button>
                </div>
              </div>
            </div>
          </div>
          <div class="calendar-body-days-e" v-for="(e, indx) in d.events" :key="indx" :class="e.cssClass"
            @click="handleClickEvent(e)"></div>
        </div>
      </div> -->
    <div class="calendar-footer"></div>
  </div>
</template>
<script>
import moment from "moment";
import {
  GetCapitalincomePlan,
  SetCapitalincomeDepPlan,
  SetCapitalincomeDayPlan,
  GetCapitalincomePlanByYear,
} from "@/api/api";
export default {
  name: "fullCalendar",
  props: {
    calEvents: Object,
  },


  mounted() {
    this.getCalendar();
    this.getCapitalincomePlan();
    // this.handleResize();
  },
  // 控制列展示时防止表头抖动
  beforeUpdate() {
    this.$nextTick(() => {
      //在数据加载完，重新渲染表格
      this.$refs.shake.doLayout();
    });
  },
  data() {
    return {
      successButton: false,
      editTableData: {
        BusinessDep: 0,
        ProjectMgrDep: 0,
        RecBusDep: 0,
        SampleDep: 0,
        ConsumablesDep: 0,
        ClinicalDep: 0,
      },
      tableKey: '',
      isShowInput: false,
      tableData: [],
      falseTrue: true,
      falseDate: '',
      SampleCost: '',
      ConsumablesCost: '',
      RecruitCost: '',
      middleData: {
        "HisDate": "",
        "SampleCost": 0,
        "ConsumablesCost": 0,
        RecruitCost: ''
      },
      headData: {},  //数据
      HisDate: '', //获取月份
      valueBusinessDep: 0,  // 一下都是头部数据
      valueProjectMgrDep: 0,
      valueRecBusDep: 0,
      valueSampleDep: 0,
      valueConsumablesDep: 0,
      valueClinicalDep: 0,  //结束
      valueFales: true,
      weekNames: ["一", "二", "三", "四", "五", "六", "日"],
      currentMonth: moment(),
      // 当前月份
      currentMonthData: [],
      UserId: "",
      OriginalDataPlanDetailItem: [],
      date: this.getDates(),
      tableHeight: 500,
    };
  },

  computed: {},
  methods: {
    // 实时检测屏幕大小
    // handleResize() {
    //   console.log(this.$refs.content.clientHeight);
    //   console.log(this.$refs.title.clientHeight);
    //   this.tableHeight = this.$refs.content.clientHeight - this.$refs.title.clientHeight;
    // },
    numberChange(val, maxNum, Serial) {
      if (Serial == 1) {
        this.valueBusinessDep = this.numberMax(val, maxNum)
      } else if (Serial == 2) {
        this.valueProjectMgrDep = this.numberMax(val, maxNum)
      } else if (Serial == 3) {
        this.valueRecBusDep = this.numberMax(val, maxNum)
      } else if (Serial == 4) {
        this.valueSampleDep = this.numberMax(val, maxNum)
      } else if (Serial == 5) {
        this.valueConsumablesDep = this.numberMax(val, maxNum)
      } else if (Serial == 6) {
        this.valueClinicalDep = this.numberMax(val, maxNum)
      } else if (Serial == 7) {
        this.SampleCost = this.numberMax(val, maxNum)
      } else if (Serial == 8) {
        this.ConsumablesCost = this.numberMax(val, maxNum)
      } else if (Serial == 9) {
        this.RecruitCost = this.numberMax(val, maxNum)
      }
    },
    // input最大数
    numberMax(val, maxNum) {
      //比较输入的值和最大值，返回小的
      let num = Math.min(Number(val), maxNum)
      //输入负值的情况下， = 0（可根据实际需求更该）
      if (num < -99999999) {
        this.$message.error("最小到负千万")
        return 0
      } else {
        //反之
        if (val > maxNum) {
          this.$message.error("最大到千万")
        }
        return num
      }
    },
    // 日历里保存按钮
    setCapitalincomeDayPlan(d) {
      console.log(d);
      if (this.falseTrue) {
        this.SampleCost = d.SampleCost
        this.ConsumablesCost = d.ConsumablesCost
        this.RecruitCost = d.RecruitCost
        d.judge = !d.judge
        console.log(111);
        this.editTableData = {
          BusinessDep: d.BusinessDep,
          ProjectMgrDep: d.ProjectMgrDep,
          RecBusDep: d.RecBusDep,
          SampleDep: d.SampleDep,
          ConsumablesDep: d.ConsumablesDep,
          ClinicalDep: d.ClinicalDep,
        };
        this.tableKey = Math.random(); // 跟新表格
        this.$forceUpdate();
        this.falseTrue = false
      } else if (d.judge) {
        // if (this.SampleCost == undefined || this.ConsumablesCost == undefined || this.RecruitCost == undefined) return this.$message.error("不能为空")
        if (
          this.editTableData.BusinessDep == undefined ||
          this.editTableData.ProjectMgrDep == undefined ||
          this.editTableData.RecBusDep == undefined ||
          this.editTableData.SampleDep == undefined ||
          this.editTableData.ConsumablesDep == undefined ||
          this.editTableData.ClinicalDep == undefined
        ) return this.$message.error("不能为空")
        // let params = {
        //   HisDate: d.date,
        //   SampleCost: this.SampleCost * 1,
        //   ConsumablesCost: this.ConsumablesCost * 1,
        //   RecruitCost: this.RecruitCost * 1,
        //   AllowEdit: 0
        // }
        // SetCapitalincomeDayPlan(params).then((res) => {
        //   if (res.data.Code != 1) this.$message.error(res.data.Msg);
        //   if (res.data.Data == true) {
        //     this.$message.success("保存成功")
        //     this.getCapitalincomePlan()
        //   }
        // });
        let params = {
          HisDate: d.HisDate,
          BusinessDep: this.editTableData.BusinessDep * 1,
          ProjectMgrDep: this.editTableData.ProjectMgrDep * 1,
          RecBusDep: this.editTableData.RecBusDep * 1,
          SampleDep: this.editTableData.SampleDep * 1,
          ConsumablesDep: this.editTableData.ConsumablesDep * 1,
          ClinicalDep: this.editTableData.ClinicalDep * 1,
          AllowEdit: 0,
          CapitalincomePlanDayList: []
        }
        this.successButton = true;
        SetCapitalincomeDepPlan(params).then((res) => {
          if (res.data.Code != 1) this.$message.error(res.data.Msg);
          if (res.data.Data) {
            this.$message.success("保存成功");
            this.getCapitalincomePlan()
            this.successButton = false;
            this.falseTrue = true
          }
        });
       
      } else {

        this.$message.error("请先保存")
      }

    },
    cancelMiddle(d) {
      this.falseTrue = true
      d.judge = !d.judge
      this.tableKey = Math.random(); // 跟新表格
      this.$forceUpdate();
    },
    // 头部保存按钮
    switchClick() {
      if (!this.valueFales) {
        let params = {
          HisDate: this.currentMonth.format("YYYY-MM-01"),
          BusinessDep: this.valueBusinessDep * 1,
          ProjectMgrDep: this.valueProjectMgrDep * 1,
          RecBusDep: this.valueRecBusDep * 1,
          SampleDep: this.valueSampleDep * 1,
          ConsumablesDep: this.valueConsumablesDep * 1,
          ClinicalDep: this.valueClinicalDep * 1,
          AllowEdit: d.AllowEdit,
          CapitalincomePlanDayList: []
        }
        SetCapitalincomeDepPlan(params).then((res) => {
          if (res.data.Code != 1) this.$message.error(res.data.Msg);
          if (res.data.Data) {
            this.$message.success("保存成功")
            this.getCapitalincomePlan()
          }
        });
      }
      this.valueBusinessDep = this.headData.BusinessDep
      this.valueProjectMgrDep = this.headData.ProjectMgrDep
      this.valueRecBusDep = this.headData.RecBusDep
      this.valueSampleDep = this.headData.SampleDep
      this.valueConsumablesDep = this.headData.ConsumablesDep
      this.valueClinicalDep = this.headData.ClinicalDep
      this.valueFales = !this.valueFales
    },
    getCalendar() {
      var thismonth = moment().format("YYYY-MM-01");

      var date = this.currentMonth; //当月
      var days = []; //星期
      var currentWeekday = moment(date)
        .date(7)
        .weekday(); // 获取当月1日为星期几
      // 标准时间
      var calFirstDay = moment(date)
        .date(1)
        .subtract(currentWeekday, "day"); //计算日历第一天

      var iswork = false;
      var isrest = false;
      for (var i = 0; i < 5; i += 1) {
        var line = { weekDays: [] };
        for (var j = 0; j < 7; j += 1) {
          // 获取节假日信息
          // 日历中的日期
          line.weekDays.push({
            day: calFirstDay.date(),
            date: calFirstDay.format("YYYY-MM-DD"),
            isCurMonth: calFirstDay.isSame(moment(date), "month"),
            showBtn: false,
            isLock: calFirstDay.format("YYYY-MM-01") <= thismonth ? false : true,
            events: [],
            ConsumablesCost: '',
            RecruitCost: '',
            SampleCost: '',
          });
          calFirstDay.add(1, "day");
        }

        days.push(line);
        //如果最后一行没有把当月日期输出完，就再加一行
        if (i === 4) {
          // 本月的1号
          var currentMonthStr = moment(date).format("YYYY-MM-01");
          var nextMonthFirst = moment(currentMonthStr).add(1, "month");
          var isBetweenNextMonth = calFirstDay.isBefore(nextMonthFirst);
          if (isBetweenNextMonth) i--;
        }
      }
      this.currentMonthData = days;
      console.log(this.currentMonthData);
      this.getTableData(this.currentMonthData);
    },
    getTableData(data) {
      this.tableData = [];
      let flag = true;
      data.forEach(item => {
        item.weekDays.forEach(d => {
          if (flag && d.day === 1) {
            flag = false;
          }
          if (flag) return;
          if (this.tableData.length > 0) {
            const day = this.tableData[this.tableData.length - 1].day;
            if (day < d.day) {
              this.tableData.push(d);
            }
          } else {
            this.tableData.push(d);
          }
        })
      })
      console.log( this.tableData);
    },

    getDates() {
      var str = new Date();
      var y = str.getFullYear();
      var m = str.getMonth() + 1 < 10 ? '0' + (str.getMonth() + 1) : str.getMonth() + 1;
      var d = str.getDate() < 10 ? '0' + str.getDate() : str.getDate();
      return y + "-" + m + "-" + d;
    },

    setEvents() {
      // this.MonthyInfo = this.calEvents.MonthyInfo;
      for (var i in this.currentMonthData) {
        var weekDays = this.currentMonthData[i].weekDays;
        for (var j in weekDays) {
          var dayData = weekDays[j];
          if (this.headData.CapitalincomePlanDayList.length > 0) {
            this.headData.CapitalincomePlanDayList.forEach((item) => {
              if (item.HisDate == dayData.date) {
                dayData.SampleCost = item.SampleCost
                dayData.ConsumablesCost = item.ConsumablesCost
                dayData.RecruitCost = item.RecruitCost
                dayData.AllowEdit = item.AllowEdit
              }
            })
          }
          dayData.judge = false
          this.tableKey = Math.random(); // 跟新表格

        }
      }
    },

    // 获取上个月
    getPrevMonth() {
      console.log(this.currentMonth);
      this.currentMonth.add(-1, "year");
      this.getCalendar();
      this.$emit("getPrevMonthData", this.currentMonth);
      this.getCapitalincomePlan()
    },
    // 获取下个月
    getNextMonth() {
      this.currentMonth.add(1, "year");
      this.getCalendar();
      this.$emit("getNextMonthData", this.currentMonth);
      this.getCapitalincomePlan()
      // 获取日历中的月份
    },
    // 获取当前月份
    getCurMonth() {
      this.currentMonth = moment();
      this.getCalendar();

      this.$emit("getCurMonthData", this.currentMonth);
      this.getCapitalincomePlan()
    },
    handleClickEvent(ev) {
      this.$emit("handleClickEvent", ev);

    },
    // 获取资金收益情况指标数据
    getCapitalincomePlan() {
      this.falseTrue = true
      this.valueFales = true
      let params = this.currentMonth.format("YYYY-MM-01")
      
      // GetCapitalincomePlan(params).then((res) => {
      //   if (res.data.Code != 1) this.$message.error(res.data.Msg);
      //   this.headData = res.data.Data
      //   console.log(this.headData);
      //   this.setEvents();
      // });
      GetCapitalincomePlanByYear(params).then((res) => {
        if (res.data.Code != 1) this.$message.error(res.data.Msg);
        this.tableData = res.data.Data;
        this.tableData = this.tableData.map(item => {
          let res = item.HisDate.split('-');
          res.splice(2, 1);
          res = res.join('-')
          item = {
            ...item,
            moon: res,
            total: item.BusinessDep + item.ProjectMgrDep + item.RecBusDep + item.SampleDep + item.ConsumablesDep + item.ClinicalDep,
          }
          return item;
        })
        console.log(this.tableData);
      });
    },
    getSummaries(param) {
      const { columns, data } = param;  // 解构
      const sums = [];
      columns.forEach((column, index) => {
      // index = 0 代表是第一列的数据
        if (index === 0) {
          sums[index] = '全年汇总：';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index]= values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0)
          // 千分位显示
          sums[index] = sums[index]
                        .toFixed(2)
                        .replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
                          return $1 + ",";
                        })
                        .replace(/\.$/, "")
          }else {
          sums[index] = '';
        }
      });
      return sums;
    },
},
  watch: {
    calEvents: function () {
      this.setEvents();
    }
  }
};
</script>

<style lang="less" scoped>
.calendar-wrapper {
  min-width: 1100px;
  height: 100%;
  display: block;
  margin: 10px;
  color: rgb(102, 102, 102);
  overflow: auto; // 自适应
}

.calendar-header-date {
  font-weight: bold;
  font-size: 18px;
  display: inline-block;
  line-height: 30px;
}

.calendar-header-date-MonthyInfo {
  font-size: 12px;
  color: red;
  display: inline-block;
  line-height: 26px;
}

.calendar-header-btns {
  display: inline-block;
  float: right;
  line-height: 31px;
}

.calendar-header-btns button {
  padding: 2px 8px;
  cursor: pointer;
  background: #fff;
  border: 1px solid rgba(102, 102, 102, 0.3);
  color: rgba(0, 0, 0, 0.5);
}

.calendar-header {
  background-color: hsla(0, 0%, 92%, 0.3);
  border: 1px solid hsla(0, 0%, 40%, 0.3);
  border-bottom: none;
  padding: 0 10px;
  // min-width: 1120px;
}

.calendar-body-header {
  display: table;
  width: 100%;
  height: 40px;
  line-height: 40px;
  table-layout: fixed;
}

.calendar-body {
  border-left: 1px solid rgba(102, 102, 102, 0.3);
  border-top: 1px solid rgba(102, 102, 102, 0.3);
}

.calendar-body-header-item {
  display: table-cell;
  text-align: center;
  font-weight: bold;
  font-size: 13px;
  border-right: 1px solid rgba(102, 102, 102, 0.3);
  border-bottom: 1px solid rgba(102, 102, 102, 0.3);
  width: 14.2%;
  height: 40px !important;
  line-height: 40px !important;
  padding: 0 !important;
}

.calendar-body-days {
  display: table;
  width: 100%;
  height: 80px;
  table-layout: fixed;
}

.calendar-body-days-item {
  // display:flex;
  display: block;
  float: left;
  // display: table-cell;
  padding: 5px;
  width: 14.282%;
  box-sizing: border-box;
  // min-width: 110px;
  height: 80px;
  position: relative;
  border-right: 1px solid rgba(102, 102, 102, 0.3);
  border-bottom: 1px solid rgba(102, 102, 102, 0.3);
}

.calendar-body-days-item:hover .dayClass {
  display: block;
}

.day_Icon {
  position: absolute;
}

.calendar-body-days-item-disabled {
  background-color: rgba(200, 200, 200, 0.2);
  color: rgba(102, 102, 102, 0.3);
}

.calendar-body-days-h {
  text-align: right;
  font-size: 13px;
}

.calendar-body-days-h-icons {
  display: inline-block;
  // float: left;
  padding-left: 45px;
  cursor: pointer;
}

.calendar-body-days-h-date {
  display: inline-block;
  width: auto;
  height: auto;
}

.calendar-body-days-h-image {
  float: right;
  width: 18px;
  height: 18px;
  background: url(../../../assets/imgs/calendar/Work.png) no-repeat;
  background-size: 18px 18px;
}

.calendar-body-days-h-image-Rest {
  float: right;
  width: 18px;
  height: 18px;
  background: url(../../../assets/imgs/calendar/Rest.png) no-repeat;
  background-size: 18px 18px;
}

.calendar-body-days-e {
  font-size: 12px;
  cursor: pointer;
  margin-top: 3px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.calendar-body-days-e-box {
  display: flex;
  flex: 1;
  font-size: 10px;
}

.calendar-body-days-e-box-title {
  /* border: 0.5px solid #ffffff; */
  background-color: green;
  color: #ffffff;
  border-radius: 5px;
  font-size: 8px;
  text-align: center;
  padding: 1px;
}

.calendar-body-days-e-box-img {
  overflow: hidden;
  width: 0;
  height: 0;
  border-top: 3px solid transparent;
  border-left: 6px solid red;

  border-bottom: 3px solid transparent;
  float: right;
  margin-right: -4px;
  margin-top: 3px;
}

.calendar-body-days-e-box-work {
  padding-left: 8px;
  font-size: 12px;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.event-red {
  color: red;
}

.event-blue {
  color: #409eff;
}

.event-gray {
  color: #666;
}

.event-green {
  color: #67c23a;
}

.event-cancel {
  // color: #ddd;
  text-decoration: line-through;
}

/deep/ .el-popover--plain {
  padding: 10px !important;
}

[note-place] {
  width: 285px;
  display: inline-block;
  vertical-align: middle;
  font-size: 12px;
}

[note-place-span-black] {
  width: 10px;
  height: 10px;
  display: inline-block;
  background-color: #666;
  margin-left: 5px;
}

[note-place-span-green] {
  width: 10px;
  height: 10px;
  display: inline-block;
  background-color: #67c23a;
  margin-left: 5px;
}

[note-place-span-blue] {
  width: 10px;
  height: 10px;
  display: inline-block;
  background-color: #409eff;
  margin-left: 5px;
}

[note-place-span-yellow] {
  width: 10px;
  height: 10px;
  display: inline-block;
  background-color: #f8d803;
  margin-left: 5px;
}

[note-place-span-red] {
  width: 10px;
  height: 10px;
  display: inline-block;
  background-color: red;
  margin-left: 5px;
}

[note-place-span-cancel] {
  width: 10px;
  height: 10px;
  display: inline-block;
  background-color: #ddd;
  margin-left: 5px;
}

.title_note img {
  width: 36px;
  vertical-align: middle;
}

.title_note {
  margin-right: 10px;
}

.title_note span {
  vertical-align: middle;
}

.title_note_box {
  font-size: 12px;
  display: flex;
  // justify-content:flex-end;
  // width: 60%;
  // float: right;
  // margin-top: -24px;
}

.inputP {
  display: flex;
  font-size: 12px;
  align-items: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-top: 5px;
  margin-right: 5px;
  word-wrap: break-word;

  /deep/ .el-input__inner {
    line-height: 18px !important;
    height: 18px !important;
    padding: 0px 4px;
    font-size: 12px;
  }
}

.inputPs {
  display: flex;
  align-items: center;
  padding-bottom: 10px;
  line-height: 35px;

  p {
    width: 100px;
  }

  /deep/ .el-input__inner {
    line-height: 25px !important;
    height: 25px !important;
    max-width: 120px !important;
    padding: 0px 4px;
  }

  /deep/ .el-button {
    border-radius: 5px !important;
  }
}

.dayClass {
  margin-top: -15px;
}

.dayClass_div {
  display: flex;
  align-items: center;
  justify-content: space-between;

  /deep/ .el-button {
    padding: 2px 4px !important;
    border-radius: 5px !important;
    margin-top: 5px;
  }
}

.dayClass_btn {
  margin-left: 5px;
  // height: 50px;
}

/deep/.numrule input::-webkit-outer-spin-button,
/deep/.numrule input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

/deep/.numrule input[type="number"] {
  -moz-appearance: textfield;
}

.table-numrule {

  /deep/.el-input__inner {
    height: 23px !important;
    padding: 0 !important;
    width: 100px !important;
  }

}
</style>


// WEBPACK FOOTER //
// src/components/customComponents/fullCalendar/fullCalendar.vue